import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { Component } from '@mycolorway/tao';

Component('tr-spreadsheet-error-counter', {
  mixins: [eventListenerMixin],
  properties: {
    errorCount: {
      type: Number,
      default: 0,
      observer() {
        this.errorEl.innerText = this.errorCount;
      },
    }
  },

  ready() {
    this.errorEl = this.querySelector('.error-num');
    this.focusErrorButton = this.querySelector('.focus-error');
    this.spreadsheet = document.querySelector('tr-spreadsheet');
    this.listenTo(this.focusErrorButton, 'click', this.focusError.bind(this));
    this.listenTo(this.spreadsheet, 'tr-spreadsheet:invalidChecked', this.changeErrorCount.bind(this));
  },

  changeErrorCount(event) {
    this.errorCount = event.detail;
  },

  focusError() {
    this.spreadsheet.selectNextErrorCell();
  },

  disconnected() {
    this.stopListening();
  },
});
